import { createAsyncThunk } from "@reduxjs/toolkit";
import serviceApi from "./api";

export const getServiceList = createAsyncThunk("services/get/loading", async (data) => {
  return serviceApi.getList(data);
});
